import { Link, Snackbar, styled } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useIO, useLinked, useModel } from "@type-r/react";
import { navigate } from "lqx-react/lib";
import * as React from "react";
import { HubBuilder } from "../api/hubBuilder";

export const NotificationAlert = React.forwardRef((props, ref) => {
    const hubBuilder = useModel(HubBuilder);
    const defaultNotificationAlert = {
        show: false,
        message: '',
        jobId: null,
        status: ''
    }

    const $stateRef = useLinked<{
        show: boolean,
        message: string,
        jobId: number,
        status: any
    }>(defaultNotificationAlert);

    const timeRef = React.useRef({ start: 0, end: 0 });
    const timetimerIdRef = React.useRef<any>();

    const setTimerNotificationAlert = (action: string) => {
        timeRef.current.start = performance.now();
        timetimerIdRef.current = setTimeout(() => {
            $stateRef.set({ show: true, message: getNotificationText(action), status: 'info', jobId: 0 });
        }, 10000);
    }

    React.useImperativeHandle(ref, () => ({
        setTimerNotificationAlert,
        clearTimer
    }));

    const isReady = useIO(async () => {
        hubBuilder.establishConnection('notificationshub');
        hubBuilder.subscribe('Notify', data => {
            timeRef.current.end = performance.now();
            const dif = timeRef.current.end - timeRef.current.start;
            if (timeRef.current.start && dif > 10000) {
                $stateRef.set({ show: true, message: data.payload.message, jobId: data.payload.jobId, status: data.status === 0 ? 'success' : 'error' });
            }
            clearTimer();
        });
    }, []);

    const getNotificationText = (action: string) =>
        `You ${action}, which may take some time to process.\
          You will receive an update when the processing is completed.`;


    const goToImportJob = () => {
        const route = `ingest/edit/${$stateRef.value.jobId}${$stateRef.value.message.includes('Digitize processing is completed.') ? '?activeStep=1' : ''}`;
        navigate(route);
        handleCloseNotification();
    }

    const handleCloseNotification = () => {
        $stateRef.set(defaultNotificationAlert);
        clearTimer();
    }

    const clearTimer = () => {
        clearTimeout(timetimerIdRef.current);
    }

    
    const StyledAlert = styled(Alert)({
        fontSize:'0.875rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
        letterSpacing: '0.01071em',
        lineHeight: '1.43'
    })



    return isReady ? <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={$stateRef.value.show}
        onClose={() => handleCloseNotification()}>
        <StyledAlert severity={$stateRef.value.status}
            onClose={() => handleCloseNotification()}>
            {$stateRef.value.message}
            {$stateRef.value.status !== 'info' &&
                <Link
                    component="button"
                    variant="body2"
                    onClick={() => goToImportJob()}>
                    job # {$stateRef.value.jobId}
                </Link>
            }
        </StyledAlert>
    </Snackbar> : <></>
})